import { useContext, useState, useEffect } from "react";

import { appDataContext } from "@/context";
import { LNG_URLS } from "@/utils/constants";
import { useLangStore } from "@/store/lang-store";
import { useNavigate } from "react-router-dom";

const LanguageSelector = () => {
  const context = useContext(appDataContext);
  const lang = context.lang;

  const { langStore, setLangStore } = useLangStore();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Ensure langState has a default value (empty string instead of undefined/null)
  const [langState, setLangState] = useState(langStore || "");

  useEffect(() => {
    if (isClient && langStore) {
        setLangState(langStore);
    }
  }, [isClient, langStore]);

  const navigate = useNavigate();
  const handleChange = (event) => {
    event?.preventDefault();
    const selectedLang = event.target.value;
    setLangState(selectedLang);
    setLangStore(selectedLang);
    if (typeof window !== "undefined") {
      localStorage.setItem("USERLANG", selectedLang);
    }
    navigate(`/${LNG_URLS[selectedLang]}`, { replace: true });
  };

  return (
    <>
      <select
        id="languagesSelect"
        className="topmenu-element language-select"
        value={isClient ? langState : ""} // Ensure value is matches server (empty) until client hydration
        onChange={handleChange}
        aria-label={lang?.help?.changeLanguage || "Change language"} // Add safe navigation and default
      >
        {Object.entries(LNG_URLS).map(([langCode, langName]) => (
          <option key={langCode} value={langCode}>
            {lang?.topmenu?.langs?.[langName]?.toUpperCase() ?? langCode.toUpperCase()} {/* Add safe navigation */}
          </option>
        ))}
      </select>
    </>
  );
};

export default LanguageSelector;
